'use client';

import {
  calculateBreakpointHighlight,
  calculateBreakpointPositions,
  BreakpointHighlight,
} from './ui.video-player-breakpoint.helpers';
import { Breakpoint } from './ui.video-player.types';

/**
 * Hook for breakpoint highlight calculations
 */
export const useBreakpointHighlight = (
  selectedBreakpointId: string | null,
  breakpoints: Breakpoint[],
  duration: number
): BreakpointHighlight | null => {
  return calculateBreakpointHighlight(
    selectedBreakpointId,
    breakpoints,
    duration
  );
};

/**
 * Hook for breakpoint positions
 */
const useBreakpointPositions = (
  breakpoints: Breakpoint[],
  duration: number,
  highlight: BreakpointHighlight | null
) => {
  return calculateBreakpointPositions(breakpoints, duration, highlight);
};

/**
 * Hook for breakpoint rendering
 * Combines highlight and positions for optimal performance
 */
export const useBreakpointRendering = (
  selectedBreakpointId: string | null,
  breakpoints: Breakpoint[],
  duration: number
) => {
  const highlight = useBreakpointHighlight(
    selectedBreakpointId,
    breakpoints,
    duration
  );
  const positions = useBreakpointPositions(breakpoints, duration, highlight);

  return {
    highlight,
    positions,
    hasHighlight: !!highlight,
  };
};
